import client from '../../client/updateLogClient';
import funDetailClient from '../../client/funDetailClient';
export default class Model {
    public resultData = null;
    public ajaxLoginData = null;

    public async save(params: any) {
        const result = await client.save(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async removeByIds(params: any) {
        const result = await client.removeByIds(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async updateById(params: any) {
        const result = await client.updateById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }
    
    public async getById(params: any) {
        const result = await client.getById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async selectPageData(params: any) {
        const result = await client.selectPageData(params);
        if (result) {
            return result;
        }
    }
    
   
}
